<template>
    <div>
<!--        <el-button type="primary" @click="ckmxFun" :disabled="disabled" :class="baseerp+'btn'" size="small" >查看明细</el-button>-->
        <el-table ref="table" size="mini" border :data="tableData" :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}">
            <el-table-column type="index" label="序号" show-overflow-tooltip width="45"></el-table-column>
            <el-table-column prop="vc_pzname" label="研发产品" show-overflow-tooltip></el-table-column>
            <el-table-column prop="f_num" label="产出数量" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_num}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_cb_price" label="单价" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_cb_price}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_rd_expenditures_total" label="总研发支出" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_rd_expenditures_total}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_tocost" label="成本金额" show-overflow-tooltip>
                <!--                不能超过总研发支出-->
                <template slot-scope="scope">
                    <el-input-number v-if="canEdit" v-model="scope.row.f_tocost" :controls="false" :max="scope.row.f_rd_expenditures_total" :min="0" @change="cbjeDchange(scope.row,scope.$index)" size="mini" :precision="2" style="width: calc(100% + 18px);margin: 0 -8px;" :placeholder="$t('form_please_enter')"></el-input-number>
                    <div class="numberCss" v-else>{{scope.row.f_tocost}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="f_rd_expenses" label="研发费用" show-overflow-tooltip >
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_rd_expenses}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="vc_gsname" label="公司" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="vc_ckname" label="仓库" show-overflow-tooltip></el-table-column>
            <el-table-column width="75px" :label="$t('form_operate')" fixed='right'>
                <template slot-scope="scope">
                    <el-button   type="text" size="small" @click="ckmxFun(scope.row)">查看明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveFun" :disabled="disabled" :class="baseerp+'btn'" size="small"v-if="canEdit" >{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="editFun" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <div :class="baseerp+'div'">
            <el-dialog :class="baseerp+'div'" style="display: flex;justify-content: center;align-items: center;"
                       width="88%" top="30"  :title="mxTitle" :visible.sync="mxDialog"
                       v-if="mxDialog" :close-on-click-modal="false" @close="mxClose" append-to-body>
                <mx-page :data="mxData" @close="mxClose"></mx-page>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import MxPage from "./MxPage"

    export default {
        name: "DetailPage",
        components: {MxPage},
        props: {
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                disabled:false,
                canEdit:false,
                mxTitle:'明细表',
                mxDialog:false,
                mxData:'',
                currentPage: 1,
                pageSize: 20,
                total:0,
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.getList();
            this.$nextTick(() => {
                this.onResize();
            })
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cbjeDchange(row,index){
                let f_rd_expenses=row.f_rd_expenditures_total-row.f_tocost;
                this.$set(this.tableData[index],'f_rd_expenses',Math.round(f_rd_expenses*100)/100);
            },
            ckmxFun(row){
                this.mxDialog=true;
                this.mxData=row;
            },
            editFun(){
                this.canEdit=true
            },
            saveFun(){
                const changedRows = this.tableData.filter((currentRow, index) => {
                    return currentRow.f_tocost !== currentRow.f_cost_amount;
                });
                if (changedRows.length === 0) {
                    this.$message.warning('请编辑数据');
                    return;
                }
                this.ExpenseToCostBatch(changedRows);
            },
            mxClose(){
                this.mxDialog=false;
            },
            cancel(){
                this.$emit('close')
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getList();
            },
            async getList(){
                let param={
                    i_gsid:this.data.i_gsid,
                    dt_jstime:this.data.dt_etime,
                };
                let res = await API.getList(param);
                if (res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    if(this.tableData.length>0){
                        this.tableData.map(t=>t.f_tocost=t.f_cost_amount)
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            async ExpenseToCostBatch(list){
                this.disabled=true;
                let param={
                    researchProductList:list,
                };
                let res = await API.ExpenseToCostBatch(param);
                if (res.code==1){
                    this.$message.success(res.message)
                    this.disabled=false;
                    this.canEdit=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .numberCss{
        text-align: right;
        font-weight: bold;
        display: inline-block;
        width: 100%;
    }
    /deep/.el-input-number.is-without-controls .el-input__inner{
        padding: 0;
    }
</style>